import styled from 'styled-components';

export const BlogContent = styled.section`
  display: flex;
  margin-top: 15px;
  flex-direction: row;
  @media (max-width: 986px) {
    flex-direction: column;
    flex-flow: column-reverse nowrap;
  }
`;

export const LeftBox = styled.section`
  width: 68%;
  margin-left: auto;
  @media (max-width: 986px) {
    width: 100%;
  }
`;

export const RightBox = styled.section`
  width: 100%;
  @media (max-width: 986px) {
    width: 100%;
    position: relative;
    padding: 0px;
    margin: 0;
  }
`;

export const PostCard = styled.div`
  background-color: #fbefcc;
  border-top: 10px solid #c94c4c;
  padding: 20px;
  border-radius: 10px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 14vw;
  margin-right: 1vh;
  transition: 600ms;
  @media (max-width: 1200px) {
    position: relative;
  }
  @media (max-width: 986px) {
    width: 100%;
    height: auto;
    margin-top: 5vh;
    position: relative;
  }
`;

export const ContainerBlog = styled.div`
  display: flex;
  flex-direction: row; /* Stack vertically on mobile */
  width: 100%;
  @media (max-width: 1200px) {
    flex-direction: column; /* Stack vertically on mobile */
  }
`;

export const FilterBlogContainer = styled.section`
  width: 20%;
  @media (max-width: 1200px) {
    width: 100%;
  }
`;

export const ListBlogContainer = styled.section`
  width: 80%;
  @media (max-width: 1200px) {
    width: 100%;
    height: auto;
    margin-top: 5vh;
  }
`;

export const BlogContainer = styled.div`
  margin: 160px 0 48px;
`;
